module.exports = __webpack_public_path__ + "static/img/23.0d69bc2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/2/zh/23.png
// module id = H/z4
// module chunks = 0